<div style="width: 100%">
  <mat-expansion-panel #panSearch class='pasuraMat1 mat-elevation-z4'  style='margin-top:20px; min-width: 800px; width:100%'  [expanded]="globserv.kontakt==undefined">

    <mat-expansion-panel-header>
      <mat-panel-title class="flex-center">
        Suche Kontakt
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <form>
        <mat-form-field class="flex-center">
          <!--<mat-label class="flex-center">Volltext-Suche </mat-label> -->
          <input class="flex-center" placeholder="Volltext-Suche" matInput [(ngModel)]="SuchText"  name="Suche" type="text">
        </mat-form-field>
      </form>
    </div>
    <button mat-flat-button [disabled]="SuchText.length<3"	color="primary"(click)="doSearch()" style="width: 100%">Suchen</button>

    <!-- Tab Kontakte  Suchen  Ergebnis-Tabelle -------------------------------- -->
    <div class='tabContacts'>
      @if (kontakte!=undefined ) {
        <mat-table  #tableContacts [dataSource]='kontakte'>
          <ng-container matColumnDef="ID">
            <mat-header-cell *matHeaderCellDef>ID</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.ID}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="Name">
            <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.Name}}</mat-cell>
          </ng-container>
          <mat-header-row table *matHeaderRowDef="displayedColumns"></mat-header-row>
 						<mat-row *matRowDef="let row; 
 							columns: displayedColumns;"
            (click)="selectContact(row)"
            class='TabRow'
            [ngClass]="{hovered: row.hovered}"
            (mouseover)="row.hovered = true"
            (mouseout)="row.hovered = false">
          </mat-row>
        </mat-table>
      }
    </div>
  </mat-expansion-panel >


  <!-- Tab Kontakte  Form -------------------------------- -->
  @if (globserv.kontakt!=undefined) {
    <mat-card class='pasuraMat1 displNormal mat-elevation-z4'>
      <mat-tab-group  #tabGroupKontakt class='TabGroup' style='min-width: 800px;' animationDuration="0ms">
        <form #frmKontakt="ngForm"  class="FormData">
          <!-- Tab Kontakte  Basisdaten -------------------------------- -->
          <mat-tab label="Kontakt"  style="margin-top: 20px; " >
            <div class='ContentTab'>
              <mat-form-field class="formularTab" style="margin-top: 20px">
                <mat-label>Kontakt-Art</mat-label>
                <mat-select  [(ngModel)]="globserv.kontakt.Bexio.contact_type_id" name="contact_type_id">
                  <mat-option  [value]='2'>Privat</mat-option>
                  <mat-option  [value]='1'>Firma</mat-option>
                </mat-select>
              </mat-form-field>
              <div >
                <mat-form-field class="formularTab">
                  <mat-label>Anrede</mat-label>
                  <input matInput placeholder="Anrede" [(ngModel)]="globserv.kontakt.Pasura.Anrede"  name="Anrede" list="salutationList">
                  <datalist id="salutationList">
                    @for (s of globserv.salutation; track s) {
                      <option >{{s.name}}</option>
                    }
                  </datalist>
                </mat-form-field>
              </div>
              @if (globserv.kontakt.Bexio.contact_type_id==2) {
                <div>
                  <mat-form-field class="formularTab">
                    <mat-label>Name</mat-label>
                    <input matInput placeholder="Name" [(ngModel)]="globserv.kontakt.Bexio.name_1"  name="name_1">
                  </mat-form-field>
                </div>
              }
              @if (globserv.kontakt.Bexio.contact_type_id==2) {
                <div>
                  <mat-form-field class="formularTab">
                    <mat-label>Vorname</mat-label>
                    <input matInput placeholder="Vorname" [(ngModel)]="globserv.kontakt.Bexio.name_2"  name="name_2">
                  </mat-form-field>
                </div>
              }
              @if (globserv.kontakt.Bexio.contact_type_id==1) {
                <div>
                  <mat-form-field class="formularTab">
                    <mat-label>Firma -</mat-label>
                    <input matInput placeholder="Firma" [(ngModel)]="globserv.kontakt.Bexio.name_1"  name="name_1">
                  </mat-form-field>
                </div>
              }
              <div>
                <mat-form-field class="formularTab">
                  <mat-label>Telefon</mat-label>
                  <input matInput placeholder="Telefon" [(ngModel)]="globserv.kontakt.Bexio.phone_fixed"  name="phone_fixed">
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="formularTab">
                  <mat-label>Telefon-Mobil</mat-label>
                  <input matInput placeholder="Telefon-Mobil" [(ngModel)]="globserv.kontakt.Bexio.phone_mobile"  name="phone_mobile">
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="formularTab">
                  <mat-label>Fax-Nummer</mat-label>
                  <input matInput placeholder="Fax-Nummer" [(ngModel)]="globserv.kontakt.Bexio.fax"  name="fax">
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="formularTab">
                  <mat-label>E-Mail</mat-label>
                  <input matInput placeholder="Mail" [(ngModel)]="globserv.kontakt.Bexio.mail"  name="mail">
                </mat-form-field>
              </div>
            </div>
          </mat-tab>
          <!-- Tab Kontakte  Adresse -------------------------------- -->
          <mat-tab  label="Adresse" >
            <div class='ContentTab'>
              <div>
                <mat-form-field class="formularTab" style="margin-top: 20px;">
                  <mat-label>c/o</mat-label>
                  <input matInput placeholder="c/o" [(ngModel)]="globserv.kontakt.Bexio.address_co"  name="address_co">
                </mat-form-field>
              </div>

				  
 					<div class="formularTab">
                <mat-form-field class="formularTab_" style="margin-top: 20px; width:80%">
                  <mat-label>Strasse</mat-label>
                  <input matInput placeholder="Strasse" [(ngModel)]="globserv.kontakt.Bexio.street_name"  name="street_name">
                </mat-form-field>
            
                <mat-form-field class="formularTab_" style="margin-top: 20px; width:20%">
                  <mat-label>Strasse Nr.</mat-label>
                  <input matInput placeholder="Strasse Nr." [(ngModel)]="globserv.kontakt.Bexio.house_number"  name="house_number">
                </mat-form-field>
              </div>                
              
              
              
              <div>
                <mat-form-field class="formularTab">
                  <mat-label>PLZ</mat-label>
                  <input matInput placeholder="Strasse" [(ngModel)]="globserv.kontakt.Bexio.postcode"  name="postcode">
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="formularTab">
                  <mat-label>Ort</mat-label>
                  <input matInput placeholder="Ort" [(ngModel)]="globserv.kontakt.Bexio.city"  name="city">
                </mat-form-field>
              </div>
            </div>
          </mat-tab>
          <!-- Tab Kontakte  Bankverbindung -------------------------------- -->
          <mat-tab  label="Bankverbindung">
            <div class='ContentTab'>
              <div>
                <mat-form-field class="formularTab" style="margin-top: 20px;">
                  <mat-label>IBAN</mat-label>
                  <input matInput placeholder="IBAN" [(ngModel)]="globserv.kontakt.Pasura.IBAN"  name="IBAN">
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="formularTab" >
                  <mat-label>Bank</mat-label>
                  <input matInput placeholder="Bank" [(ngModel)]="globserv.kontakt.Pasura.Bank"  name="Bank">
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="formularTab" >
                  <mat-label>Bankort</mat-label>
                  <input matInput placeholder="Bankort" [(ngModel)]="globserv.kontakt.Pasura.Bankort"  name="Bankort">
                </mat-form-field>
              </div>
            </div>
          </mat-tab>
          <!-- Tab Kontakte  Funktionen -------------------------------- -->
          <mat-tab  label="Funktionen" style="min-width: 450px;">
            <div class='ContentTab' >
              <div  style="margin-top: 40px; max-width: 100%; overflow-x: hidden;">
                <mat-chip-list multiple >
                  <!--
                  <mat-chip-option layout-align="end left" selectable="true"
                    (click)="globserv.kontakt.Mitglied= (!globserv.kontakt.Mitglied)"
                    [selected]="globserv.kontakt.Mitglied">
                    Mitglied &nbsp;
                  </mat-chip-option>
                  -->
                  <mat-chip-option  layout-align="end left"  selectable="true"
                    (click)="globserv.kontakt.Vorstand= (!globserv.kontakt.Vorstand)"
                    [selected]="globserv.kontakt.Vorstand">
                    Vorstand &nbsp;
                  </mat-chip-option>
                  <mat-chip-option  layout-align="end left"  selectable="true"
                    (click)="globserv.kontakt.Ausschuss= (!globserv.kontakt.Ausschuss)"
                    [selected]="globserv.kontakt.Ausschuss">
                    Ausschuss
                  </mat-chip-option>
                </mat-chip-list>
              </div>
              <div  style="margin-top: 40px; max-width: 100%; overflow-x: hidden;" layout-align="space-around" >
                <mat-chip-list multiple>
                  <mat-chip-option selectable="true"
                    (click)="globserv.kontakt.Tierarzt= (!globserv.kontakt.Tierarzt)"
                    [selected]="globserv.kontakt.Tierarzt">
                    Tierarzt &nbsp;
                  </mat-chip-option>
                </mat-chip-list>
              </div>
            </div>
          </mat-tab>
          <!-- Tab Kontakte  Bemerkung -------------------------------- -->
          <mat-tab  label="Personen" style="min-width: 850px;">
            <div class='ContentTab formularTabPers' >
              <app-personen   >Loading..</app-personen>
            </div>
          </mat-tab>
          <!-- Tab Kontakte  Bemerkung -------------------------------- -->
          <mat-tab  label="Bemerkung {{(globserv.kontakt.Pasura.Bemerkung.length>0 ||globserv.kontakt.Pasura.Bemerkung_2.length>0)?'*':''}}">
            <div class='ContentTab'>
              <div>
                <mat-form-field class="formularTab" style="margin-top: 20px;">
                  <mat-label>Bemerkung</mat-label>
                  <textarea matInput placeholder="Bemerkungen" [(ngModel)]="globserv.kontakt.Pasura.Bemerkung"  name="Bemerkung"></textarea>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="formularTab" >
                  <mat-label>Bemerkung 2</mat-label>
                  <textarea matInput placeholder="Bemerkung 2" [(ngModel)]="globserv.kontakt.Pasura.Bemerkung_2"  name="Bemerkung_2"></textarea>
                </mat-form-field>
              </div>
            </div>
          </mat-tab>
        </form>
      </mat-tab-group >
      @if (tabGroupKontakt !=undefined && tabGroupKontakt.selectedIndex!=4) {
        <div style="text-align:center; margin-bottom: 15px">
          <button mat-flat-button [disabled]="kontaktChanged()"	color="primary"(click)="resetKontakte()" >abbrechen</button>
          &nbsp;
          <button mat-flat-button [disabled]="kontaktChanged()"	color="primary"(click)="saveKontakte()" style="margin-left: 30px;" >speichern</button>
        </div>
      }
    </mat-card>
  }
  <br>
  </div>
